import { ReactElement, useContext } from "react";

import { Asset } from "../../generated/gql/graphql";
import { CategoryContext } from "../../providers/category-provider";
import { ConfirmationModalType } from "../../types/confirm-modal";
import { findRootCategoryById } from "../../utils";

import CollectionAssetGridItem from "./CollectionAssetGridItem";

type Props = {
  collectionId: string;
  assets: Asset[];
  setConfirm: (val: ConfirmationModalType) => void;
};

export default function CollectionAssetGrid(props: Props): ReactElement {
  const { assets, collectionId, setConfirm } = props;
  const { categories } = useContext(CategoryContext);

  return (
    <>
      {assets.map((asset) => (
        <CollectionAssetGridItem
          key={asset.id}
          asset={asset}
          setConfirm={setConfirm}
          rawCollectionId={collectionId}
          collectionId={findRootCategoryById(
            asset?.categoryId || "",
            categories
          )}
        />
      ))}
    </>
  );
}
